import { useParams } from 'react-router-dom';
import { ModuleDetailView } from '@/views/ModuleDetailView';
import { MainLayout } from '@/widgets/layouts/MainLayout';

const ModuleDetailPage = () => {
  const { courseId, intakeId, groupNumber, termId, moduleId } = useParams<{
    courseId: string;
    intakeId: string;
    groupNumber: string;
    termId: string;
    moduleId: string;
  }>();

  if (!courseId || !intakeId || !groupNumber || !termId || !moduleId) {
    return null;
  }

  return (
    <MainLayout headerTitle="Module Detail">
      <ModuleDetailView
        courseId={Number(courseId)}
        intakeId={Number(intakeId)}
        groupNumber={Number(groupNumber)}
        termId={Number(termId)}
        moduleId={Number(moduleId)}
      />
    </MainLayout>
  );
};

export default ModuleDetailPage;

